import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
    Button
} from "reactstrap";
// core components
import Header from "../../../../components/headers/Header";
import LoadingIndicator from "../../../../components/ui/LoadingIndicator";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Upload, Button as AntdBtn } from "antd";
import "antd/dist/antd.css";
import { UploadOutlined } from "@ant-design/icons";
import { useForm } from "react-hook-form";
import ReduxBlockUi from "react-block-ui/redux";
import * as Helper from "../../../../utils/Helper"
import MessageBox from "../../../../components/ui/MessageBox";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../../../redux/screens/admin/dictionary/pinyin/EditRedux";
import AuthorizedScreen from "../../../../components/base/AuthorizedScreen";
import { NavigationService, NavigateActionTypes } from "../../../../navigation";
import UIDs from "../../../../UIDs";
import PinyinEditService from "../../../../services/screens/admin/dictionary/pinyin/EditService";
import AudioRecorder from "../../../../components/ui/AudioRecorder";
// import AppConfig from "../../../../config/AppConfig";

const uid = UIDs.screens.admin.dictionary.pinyin.edit;

class EditScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: null, error: this._handleAsyncActionError },
            [ActionTypes.SAVE_PINYIN_ASYNC]: {
                done: this._handleSavePinyinAsyncDone,
                error: this._handleAsyncActionError
            }
        };
    }

    localVars = {
        navParams: {
            spelling: null,
            searchVO: null,
        }
    };

    constructor(props) {
        super(props);

        this.localVars.navParams = NavigationService.getNavParams(props);
    }

    componentDidMount() {
        super.componentDidMount();

        const { spelling } = this.localVars.navParams;

        if (spelling)
            this.props.loadScreenViewAsync(spelling);
        else
            this.props.createPinyin();
    }

    render() {
        const { pinyin } = this.props.localState;
        return (
            <>
                <Header />
                <Container className="mt--7" fluid>
                    <Row>
                        <div className="col">
                            {!pinyin || this.isActionExecuting(ActionTypes.LOAD_SCREEN_VIEW_ASYNC) || this.isActionExecuting(ActionTypes.SAVE_PINYIN_ASYNC)
                                ? <LoadingIndicator />
                                :<ReduxBlockUi>
                                    <EditForm
                                        {...this.props}
                                        pinyin={pinyin}
                                        onSave={this._handleSavePinyin}
                                        onCancel={this._handleCancelSavePinyin}
                                        uploadAudioAsync={this.props.uploadAudioAsync}
                                        generateAudioAsync={this.props.generateAudioAsync}
                                    />
                                </ReduxBlockUi>

                            }
                        </div>
                    </Row>
                </Container>
            </>
        );
    }

    _handleSavePinyin = (data) => {
        confirmAlert({
            title: this.props.t("confirmToSave"),
            message: this.props.t("sureToDo"),
            buttons: [
                {
                    label: this.props.t("yes"),
                    onClick: () => {
						this.props.savePinyinAsync(data);
                    }
                },
                {
                    label: this.props.t("no")
                }
            ]
        });
    }

    _handleSavePinyinAsyncDone = () => {
        NavigationService.navigateToPageByUID(this, UIDs.screens.admin.dictionary.pinyin.list, {searchVO: this.localVars.navParams.searchVO});
    };

    _handleCancelSavePinyin = () => {
        NavigationService.navigateToPageByUID(this, UIDs.screens.admin.dictionary.pinyin.list, {searchVO: this.localVars.navParams.searchVO});
    };

    _handleAsyncActionError = (action) => {
        this.displayError(action.error);
    };
}

function EditForm(props) {
    const { pinyin } = props;
    const { spelling, letter, audio } = pinyin;
    const { register, handleSubmit, errors, getValues } = useForm();
    const submitInputRef = useRef();

    const [state_audio, setstate_audio] = useState(audio);

    const [state_generating, setstate_generating] = useState(false);

    const uploadAudioButton = (
        <AntdBtn>
            <UploadOutlined />{props.t("upload")}
        </AntdBtn>
    );

    const uploadAudioProps = {
        name: "fileData",
        showUploadList: false, // set to only upload one file            
        customRequest: info => {
            PinyinEditService.upload(
                info.file,
                response => {
                    setstate_audio(response.virtualPath);
                },
                error => {
                    MessageBox.danger({ text: error.message, duration: 5000 });
                    // this.displayError(error);
                }
            )
            // props.uploadAudioAsync(info.file);
        },
        beforeUpload: file => {
            const isMp3 = Helper.isMp3(file.type);
            if (!isMp3) {
                MessageBox.danger({ text: props.t("uploadAudioFormatLimited"), duration: 5000 });
                return false;
            }
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                MessageBox.danger({ text: props.t("uploadAudioSizeLimited", { fileSize: 2 }), duration: 5000 });
                return false;
            }
            return isMp3 && isLt2M;
        }
    };

    const handleGenerateAudio = () => {
        setstate_generating(true);
        var formData = getValues();
        var letter = [];
        letter.push(formData.letter);
        PinyinEditService.generateAudio(
            letter,
            response => {
                setstate_generating(false);
                setstate_audio(response.words.length > 0 ? response.words[0].virtualPath : null);
            },
            error => {
                setstate_generating(false);
                MessageBox.danger({ text: error.message, duration: 5000 });
            }
        )
    }
    const clearAudio = () => {
        setstate_audio("");
    }
    const onSave = (formData) => {
        let submitData = {
            ...formData,
            audio: state_audio
        }
        props.onSave(submitData);
    }

    const handleRecordEnd = (blob) => {
        let file = new File([blob], "recordFile.wav");
        PinyinEditService.upload(
			file,
			(response) => {
				setstate_audio(response.virtualPath);
			},
			(error) => {
				//this.displayError(error);
				MessageBox.danger({ text: error.message, duration: 5000 });
			}
		);
    }

    let audioElement = null;
    if (Helper.isNullOrEmpty(state_audio)) {
        audioElement = (
            <div className="row align-items-center">
                <div className="col-lg-1">
                    <div className="form-group">
                        <button type="button" className="btn btn-default" onClick={() => { handleGenerateAudio(); }}>{state_generating ? props.t("generating") : props.t("generate")}</button>
                    </div>
                </div>
                <div className="col-lg-1" style={{ marginLeft: "60px", padding: 0 }}>
                    <div className="form-group">
                        {props.t("or")}
                    </div>
                </div>
                <div className="col-lg-1" style={{ marginLeft: "30px", padding: 0 }}>
                    <div className="form-group">
                        <Upload {...uploadAudioProps}>
                            {uploadAudioButton}
                        </Upload>
                    </div>
                </div>
                <div className="col-lg-1" style={{ marginLeft: "80px", padding: 0 }}>
                    <div className="form-group">
                        <AudioRecorder
                            onRecordDelete={() => {
                                clearAudio();
                            }}
                            onRecordError={(error) => {
                                MessageBox.danger({ text: error.message, duration: 5000 });
                            }}
                            onRecordEnd={handleRecordEnd.bind(this)}
                        />
                    </div>
                </div>
            </div>
        );
    } else {
        audioElement = (
            <div className="row">
                <div className="col-lg-4">
                    <audio controls preload="none" controlsList="nodownload" src={Helper.convertToFileServerPath(state_audio + "?" + Math.random())}>
                        <track kind="captions" />
                        Your browser does not support the audio element.
                    </audio>
                </div>
                <div className="col-lg-1">
                    <div className="form-group">
                        <button type="button" className="btn btn-default" onClick={() => { clearAudio(); }}>{props.t("delete")}</button>
                    </div>
                </div>
            </div>
        );
    }
    return (
        <Card className="shadow">
            <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                    <Col xs="8">
                        <h3 className="mb-0">{props.t("pinyin")}</h3>
                    </Col>
                    <Col className="text-right" xs="4">
                        <Button
                            color="info"
                            onClick={() => submitInputRef.current.click()}
                            size="sm">
                            {props.t("save")}
                        </Button>&nbsp;
                        <Button
                            color="default"
                            onClick={props.onCancel}
                            size="sm">
                            {props.t("cancel")}
                        </Button>
                    </Col>
                </Row>
            </CardHeader>
            <CardBody>
                <form onSubmit={handleSubmit(onSave)}>
                    <div className="pl-lg-4">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("spelling")}</label>
                                    <input disabled={JSON.stringify(pinyin) !== "{}"} name="spelling" type="text"
                                        className="form-control-alternative form-control" defaultValue={spelling}
                                        ref={register({ required: true })} />
                                    {errors.spelling && <span className="text-danger">{props.t("fieldIsRequired")}</span>}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("letter")}</label>
                                    <input name="letter" className="form-control-alternative form-control"
                                        defaultValue={letter}
                                        ref={register} />
                                    {errors.letter && <span className="text-danger">{props.t("fieldIsRequired")}</span>}
                                </div>
                            </div>
                        </div>
                        {audioElement}
                    </div>
                    <input ref={submitInputRef} type="submit" hidden />
                </form>
            </CardBody>
        </Card>
    );
}

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadScreenViewAsync: pinyin => dispatch(Actions.loadScreenViewAsync(pinyin)),
        savePinyinAsync: vo => dispatch(Actions.savePinyinAsync(vo)),
        createPinyin: () => dispatch(Actions.createPinyin())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(EditScreen));
